const initialState = {
  apartment_information: {
    landlord: "",
    number_of_rooms: "",
    selected_number_of_rooms: "",
    security_door: false,
    insurance_start: "",
    comprehensive_insurance: false,
    increased_travel_protection: false,
    personal_accident_insurance: false,
    tenant_insurance: false,
    small_boats_insurance: false,
    number_personal_accident_insurances: "",
    
    selected_number_personal_accident_insurances: "",
    first_personal_accident_insurances_name: "",
    first_personal_accident_insurances_ssn: "",
    second_personal_accident_insurances_name: "",
    second_personal_accident_insurances_ssn: "",
    third_personal_accident_insurances_name: "",
    third_personal_accident_insurances_ssn: "",
    fourth_personal_accident_insurances_name: "",
    fourth_personal_accident_insurances_ssn: "",
    fifth_personal_accident_insurances_name: "",
    fifth_personal_accident_insurances_ssn: "",
    
    other_information: "",
    contact_me: false,
    
    contact_me_area: [
      {
        id: "1",
        name: "Bilförsäkring"
      },
      {
        id: "2",
        name: "Bank"
      },
      {
        id: "3",
        name: "Olycksfallsförsäkring"
      },
      {
        id: "4",
        name: "Förebygga skada"
      },
      {
        id: "5",
        name: "Övriga frågor"
      }
    ],
    selected_contact_me_area: undefined,
    selected_additional_jewelry_insurance: undefined,
    want_information_on: "",
    selected_payment_method: ""
  }
};

export default (state = initialState, action) => {
  switch (action.type) {

    case "SET_PRIVATE_INSURANCE_DATA":
      return {
        ...state,
        apartment_information: Object.assign(
          {},
          state.apartment_information,
          action.payload
        )
      };

    case "UPDATE_FIRST_PRIVATE_INSURANCE_PERSON_SUCCESS":
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          first_personal_accident_insurances: action.payload.value
        }
      });

    case "UPDATE_SECOND_PRIVATE_INSURANCE_PERSON_SUCCESS":
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          second_personal_accident_insurances: action.payload
        }
      });

    case "UPDATE_THIRD_PRIVATE_INSURANCE_PERSON_SUCCESS":
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          third_personal_accident_insurances: action.payload
        }
      });

    case "UPDATE_FOURTH_PRIVATE_INSURANCE_PERSON_SUCCESS":
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          fourth_personal_accident_insurances: action.payload
        }
      });

    case "UPDATE_FIFTH_PRIVATE_INSURANCE_PERSON_SUCCESS":
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          fifth_personal_accident_insurances: action.payload
        }
      });

    case "SET_COMPREHENSIVE_INSURANCE_DATA_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          comprehensive_insurance: action.data.bool
        }
      });
    }

    case "SET_SELECTED_PAYMENT_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          selected_payment_method: action.data
        }
      });
    }

    case "SET_INCREASED_TRAVEL_PROTECTION_INSURANCE_DATA_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          increased_travel_protection: action.data.bool
        }
      });
    }

    case "SET_PERSONAL_ACCIDENT_INSURANCE_DATA_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          personal_accident_insurance: action.data.bool
        }
      });
    }

    case "SET_TENTANT_INSURANCE_DATA_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          tenant_insurance: action.data.bool
        }
      });
    }

    case "SET_SMALL_BOATS_INSURANCE_DATA_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          small_boats_insurance: action.data.bool
        }
      });
    }
    
    case "ADD_SECURITY_DOOR_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          security_door: action.data
        }
      });
    }

    case "ADD_CONTACT_ME_DATA_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          contact_me: action.data.bool
        }
      });
    }

    case "SET_APARTMENT_DATA_SUCCESS":
      return {
        ...state,
        apartment_information: Object.assign(
          {},
          state.apartment_information,
          action.payload
        )
      };

    case "SET_SELECT_ROOMS_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          number_of_rooms: action.data,
          selected_number_of_rooms: action.data.name
        }
      });
    }
    
    case "SET_SELECT_CONTACT_AREA_SUCCESS": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          selected_contact_me_area: action.data.name
        }
      });
    }

    case "SET_INSURANCE_START": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          insurance_start: action.data
        }
      })
    }

    case "SET_SELECTED_NUMBER_PRIVATE_ACCIDENT_INSURANCE": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          number_personal_accident_insurances: action.data,
          selected_number_personal_accident_insurances: action.data.name
        }
      });
    }

    case "SET_ADDITIONAL_JEWELRY_INSURANCE": {
      return Object.assign({}, state, {
        apartment_information: {
          ...state.apartment_information,
          selected_additional_jewelry_insurance: action.data
        }
      });
    }

    default:
      return state;
  }
};
